import cn from 'classnames';
import { AuditReport, ScanSource } from '../digital-audit-constants';

interface ScanSourceBadgeProps {
  scanSource: AuditReport['scanSource'];
  // Only meaningful (and only ever passed) for scanSource FULL - a partial
  // crawl still merges real data (see AuditReport.fullScanPageCoverage), so
  // callers that care how much of the crawl is reflected can surface it here
  // instead of leaving "Full scan" implying every page completed.
  pageCoverage?: AuditReport['fullScanPageCoverage'];
}

// FullScanStatusBanner communicates a full scan's transient progress/outcome
// and is dismissible - once dismissed (or once its "merged" moment has
// scrolled past), nothing on the report itself said whether what's currently
// on screen is the quick-scan preview or the full-browser crawl. This is
// non-dismissible and rendered in the page header on every tab so that's
// never ambiguous.
export const ScanSourceBadge = ({ scanSource, pageCoverage = null }: ScanSourceBadgeProps) => (
  <span
    className={cn('digital-audit-chbadge', scanSource === ScanSource.FULL ? 'good' : 'lim')}
    style={{ marginRight: 12 }}
  >
    {scanSource === ScanSource.FULL ? 'Full scan' : 'Quick scan'}
    {scanSource === ScanSource.FULL &&
      pageCoverage &&
      ` · ${pageCoverage.pagesCaptured}/${pageCoverage.pagesTotal} pages`}
  </span>
);
